const { fetchWithRetry } = require('./utils'); // A utility function to parse cookies  

// Fetch all products  
const fetchAllProducts = async () => {
    try {
        const response = await fetchWithRetry('/api/products/all', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Failed to fetch products');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};

// Fetch a single product by ID  
const fetchProductById = async (id) => {
    try {
        const response = await fetchWithRetry('/api/products/get', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
        });

        if (!response.ok) {
            throw new Error('Failed to fetch product');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching product:', error);
        throw error;
    }
};

// Create a new product  
const createProduct = async (image, description, price) => {
    try {
        const response = await fetchWithRetry('/api/products', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ image, description, price }),
        });

        if (!response.ok) {
            throw new Error('Failed to create product');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error creating product:', error);
        throw error;
    }
};

// Delete a product  
const deleteProduct = async (id) => {
    try {
        const response = await fetchWithRetry('/api/products/delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
        });

        if (!response.ok) {
            throw new Error('Failed to delete product');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting product:', error);
        throw error;
    }
};

// Edit a product  
const editProduct = async (id, image, description, price) => {
    try {
        const response = await fetchWithRetry('/api/products/edit', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id, image, description, price }),
        });

        if (!response.ok) {
            throw new Error('Failed to edit product');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error editing product:', error);
        throw error;
    }
};

module.exports = {
    fetchAllProducts,
    fetchProductById,
    createProduct,
    deleteProduct,
    editProduct,
};  